import { MEANINGFUL_DELTA } from '../../constants';

// What the band comes to: the eyebrow, headline and note at their line heights,
// plus the 18px padding above and below them. The loader standing in for the
// band is drawn at this height, so it takes up the room the band is about to
// and nothing below it shifts when the content lands. Worth re-measuring if the
// type sizes or the padding in index.scss change.
export const BANNER_HEIGHT = 140;

export const BANNER_TEXT = {
    eyebrow: 'Comparing',
    // The count and its noun are emphasised together ("50 participants"), the
    // clause after them isn't — so they're separate strings rather than one
    // sentence pulled apart at render time.
    comparedUnit: 'participants',
    comparedClause: 'compared against',
    // Stands in when the pairing doesn't name a mode: the phrasing the toggle
    // uses, which is true whichever earlier 360 each participant was matched to.
    comparedDefaultBaseline: 'their own earlier 360',
    notCompared: 'not compared',
    // Built from the threshold the sections actually apply, so the number here
    // can't drift away from the one deciding what gets muted.
    muted: `Changes under ${MEANINGFUL_DELTA.toFixed(2)} are shown muted.`,
};

// "13 to 18 months", or "13 months" when every pair sits the same distance
// apart — a range that reads "13 to 13" would look like a mistake.
//
// null when the response didn't report the gap, so the note is left to the
// sentence that doesn't depend on it rather than filling in a guess.
export const intervalSentence = (from, to) => {
    if (typeof from !== 'number' || typeof to !== 'number') return null;
    const months = (count) => `${count} month${count === 1 ? '' : 's'}`;
    return from === to
        ? `Intervals run ${months(from)}.`
        : `Intervals run ${from} to ${months(to)}.`;
};
